import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeAgo',
  standalone: true,
  pure: true,
})
export class TimeAgoPipe implements PipeTransform {
  transform(value: string | Date | null | undefined): string {
    if (!value) {
      return '';
    }

    const date = value instanceof Date ? value : new Date(value);
    if (isNaN(date.getTime())) {
      return '';
    }

    const diffSec = Math.max(
      0,
      Math.floor((Date.now() - date.getTime()) / 1000),
    );

    if (diffSec < 60) {
      return 'Hace unos segundos';
    }

    const diffMin = Math.floor(diffSec / 60);
    if (diffMin < 60) {
      return `Hace ${diffMin} min`;
    }

    const diffHr = Math.floor(diffMin / 60);
    if (diffHr < 24) {
      return `Hace ${diffHr} hr`;
    }

    const diffDay = Math.floor(diffHr / 24);
    if (diffDay < 30) {
      return `Hace ${diffDay} d`;
    }

    const diffMonth = Math.floor(diffDay / 30);
    if (diffMonth < 12) {
      return `Hace ${diffMonth} mes${diffMonth > 1 ? 'es' : ''}`;
    }

    const diffYear = Math.floor(diffMonth / 12);
    return `Hace ${diffYear} año${diffYear > 1 ? 's' : ''}`;
  }
}
